import React, {useState} from "react";
import {connect} from "react-redux";
import cx from "classnames";
import 'moment/locale/ru';
import {DropdownItem, DropdownMenu, DropdownToggle, Input, Modal, ModalBody, UncontrolledDropdown,} from "reactstrap";
import {useTranslation} from "react-i18next";
import get from "lodash/get";
import filter from "lodash/filter";

import {updateChatFilters, addingNewContactToggleModal, importNewContactsToggleModal} from "../../../actions/Chats";
import {getDisplayName} from '../Messages/TopPane';
import {postRequestDjango} from "../../../../src/requests";

const ChatFiltersDropdown = (
    {
        chatFilters,
        currentShopAdministrator,
        activeShopAdministrators,
        activeShop,

        // Redux Actions
        updateChatFilters,
        addingNewContactToggleModal,
        importNewContactsToggleModal,
    }
) => {
    const {t, i18n} = useTranslation();


    let operatorDropdownItems = filter(
        activeShopAdministrators,
        (shopAdministrator) => {
            if (!shopAdministrator) {
                return false;
            }

            // Не выводим себя
            if (shopAdministrator.id === get(currentShopAdministrator, 'id')) {
                return false;
            }

            // Выводим только операторов чата
            if (!shopAdministrator.role_live_chat_operator) {
                return false;
            }

            return true;
        },
    ).map(
        shopAdministrator => {
            const isActive = get(chatFilters, 'assigned_to_id') === shopAdministrator.id;

            return <DropdownItem
                key={shopAdministrator.id}
                className={cx({'active': isActive})}
                toggle={false}
                onClick={(event) => {
                    event.stopPropagation();
                    updateChatFilters({assigned_to_id: shopAdministrator.id})
                }}
            >
                {getDisplayName(shopAdministrator)}
            </DropdownItem>;
        }
    );

    return <UncontrolledDropdown className='chat-filters-dropdown'>
        <DropdownToggle color='null'>
            <i className="pe-7s-edit"/>
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-hover-link">
            <DropdownItem onClick={() => {addingNewContactToggleModal(true);}}>
                {t('chats.filter_dropdown.adding_a_user', "Adding a user")}
            </DropdownItem>
            <DropdownItem onClick={() => importNewContactsToggleModal(true)}>
                {t('chats.filter_dropdown.import_contacts', "Import contacts")}
            </DropdownItem>
            <DropdownItem header>{t('chats.filter_dropdown.is_thread_open_title', "Live chat")}</DropdownItem>
            <DropdownItem
                toggle={false}
                className={cx({'active': get(chatFilters, 'is_thread_open') === true})}
                onClick={() => {updateChatFilters({is_thread_open: true});}}
            >
                {t('chats.filter_dropdown.is_thread_open_open', "Open")}
            </DropdownItem>
            <DropdownItem
                toggle={false}
                className={cx({'active': get(chatFilters, 'is_thread_open') === false})}
                onClick={() => {updateChatFilters({is_thread_open: false});}}
            >
                {t('chats.filter_dropdown.is_thread_open_closed', "Closed")}
            </DropdownItem>

                <DropdownItem divider/>
                <DropdownItem header>{t('chats.filter_dropdown.assigned_to_title', "Assigned to")}</DropdownItem>
                <DropdownItem
                    toggle={false}
                    className={cx({'active': get(chatFilters, 'assigned_to_id') === null})}
                    onClick={() => {
                        updateChatFilters({assigned_to_id: null});
                    }}
                >
                    {t('chats.filter_dropdown.assigned_to_nobody', "Not assigned")}
                </DropdownItem>
                {
                    currentShopAdministrator && <DropdownItem
                        toggle={false}
                        className={cx({'active': get(chatFilters, 'assigned_to_id') === get(currentShopAdministrator, 'id')})}
                        onClick={() => updateChatFilters({assigned_to_id: currentShopAdministrator.id})}
                    >
                        {t('chats.filter_dropdown.assigned_to_me', "To me")}
                    </DropdownItem>
                }

                {operatorDropdownItems}
            </DropdownMenu>
        </UncontrolledDropdown>
};


const mapStateToProps = state => ({
    activeChat: state.Chats.activeChat,
    chatFilters: state.Chats.chatFilters,
    currentShopAdministrator: state.Shops.currentShopAdministrator,
    activeShopAdministrators: state.Shops.activeShopAdministrators,
});

const mapDispatchToProps = dispatch => ({
    updateChatFilters: (filtersToUpdate) => dispatch(updateChatFilters(filtersToUpdate)),
    addingNewContactToggleModal: (bool) => dispatch(addingNewContactToggleModal(bool)),
    importNewContactsToggleModal: (bool) => dispatch(importNewContactsToggleModal(bool)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatFiltersDropdown);
